"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetEnrichAiAPIUrl = exports.useGetEnrichAPIUrl = void 0;
exports.getAllData = getAllData;
const hooks_1 = require("../hooks");
const useGetEnrichAPIUrl = () => {
    const { enrichApiPrefix, } = (0, hooks_1.useEnvironmentConfig)();
    return enrichApiPrefix;
};
exports.useGetEnrichAPIUrl = useGetEnrichAPIUrl;
const useGetEnrichAiAPIUrl = () => {
    const { enrichAIApiPrefix, } = (0, hooks_1.useEnvironmentConfig)();
    return enrichAIApiPrefix;
};
exports.useGetEnrichAiAPIUrl = useGetEnrichAiAPIUrl;
const LIMIT_MAX = 500;
function getAllData(repo, filter) {
    return __awaiter(this, void 0, void 0, function* () {
        const items = [];
        const total = yield repo.getTotal(filter);
        const pagesCount = Math.ceil(total / LIMIT_MAX);
        for (let i = 0; i < pagesCount; i++) {
            items.push(repo.getMany({
                filter,
                page: {
                    limit: LIMIT_MAX,
                    offset: i * LIMIT_MAX,
                },
            }));
        }
        return Promise.all(items);
    });
}
